import { useContext, useLayoutEffect, type ReactNode } from 'react';
import styled from 'styled-components';

import { MainContentSurfaceContext } from '../../layouts/MainContentSurfaceContext';

/**
 * Серая канва для внешних страниц (детальный просмотр): аналог фона вокруг InfoBlock
 * в web-client (ToolsPanelPage + InfoBlock).
 */
const Root = styled.div`
  box-sizing: border-box;
  min-height: 100%;
  background: ${({ theme }) => theme.colors.background};
  padding: 0 ${({ theme }) => theme.layout.externalPage.gutterDesktop}px
    ${({ theme }) => theme.space[4]}px;

  ${({ theme }) => theme.device.mobile} {
    padding: 0 ${({ theme }) => theme.layout.pagePaddingMobile}px
      ${({ theme }) => theme.space[2]}px;
  }
`;

export interface ExternalPageCanvasProps {
  children: ReactNode;
}

export function ExternalPageCanvas({ children }: ExternalPageCanvasProps) {
  const mainSurface = useContext(MainContentSurfaceContext);

  useLayoutEffect(() => {
    if (!mainSurface) {
      return;
    }
    mainSurface.setSurface('external');
    return () => {
      mainSurface.setSurface('default');
    };
  }, [mainSurface]);

  return <Root>{children}</Root>;
}
